import {
  useFindAllCompaniesQuery,
  useFindAllLicensesQuery,
  useFindAllSoftwareQuery,
  useGetAllTypesQuery,
} from '../../api/api-hooks';
import FilterBar from '../../components/FilterBar';
import {
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import { filterConstraintChecker } from './softwareSoldUtils';
import { SoftwareSoldItemFilter } from './softwareSoldTypes';

interface Props {
  filters: SoftwareSoldItemFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: SoftwareSoldItemFilter;
}

const SoftwareSoldFilterBar = ({
  filters,
  setFilters,
  initialFilters,
}: Props) => {
  const { data: licenses } = useFindAllLicensesQuery({});
  const { data: hardwareTypes } = useGetAllTypesQuery({});
  const { data: companies } = useFindAllCompaniesQuery({});
  const { data: softwareTypes } = useFindAllSoftwareQuery({});
  if (
    licenses === undefined ||
    hardwareTypes === undefined ||
    companies === undefined ||
    softwareTypes === undefined
  )
    return <CircularProgress></CircularProgress>;

  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={filterConstraintChecker}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'company');
            }}
            value={filters.company}
            options={companies}
            getOptionLabel={(company) => company.companyName}
            style={{ width: 200 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label=' Company'
                name='company'
                variant='outlined'
                id='company'
              />
            )}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'hardwareType');
            }}
            value={filters.hardwareType}
            options={hardwareTypes}
            getOptionLabel={(type) => type.typeName}
            style={{ width: 200 }}
            renderInput={(params) => (
              <TextField {...params} label='Hardware Type' variant='outlined' />
            )}
          />,
          <TextField
            name='serial'
            label=' Serial'
            variant='outlined'
            value={filters.serial}
            onChange={handler}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'software');
            }}
            value={filters.software}
            options={softwareTypes}
            getOptionLabel={(type) => type.type}
            style={{ width: 200 }}
            renderInput={(params) => (
              <TextField {...params} label='Software Type' variant='outlined' />
            )}
          />,
          <Grid
            container
            justifyContent='flex-start'
            alignItems='center'
            spacing={1}
          >
            <Grid item>
              <Typography>Sold From:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name='soldDateFrom'
                variant='outlined'
                type='date'
                style={{ width: 175 }}
                value={filters.soldDateFrom}
                onChange={handler}
              />
            </Grid>
            <Grid item>
              <Typography>To:</Typography>
            </Grid>
            <Grid item>
              <TextField
                name='soldDateTo'
                variant='outlined'
                type='date'
                style={{ width: 175 }}
                value={filters.soldDateTo}
                onChange={handler}
              />
            </Grid>
          </Grid>,
          <Select
            name='supportStatus'
            value={filters.supportStatus}
            variant='outlined'
            displayEmpty={true}
            renderValue={(value: any) => (value ? value : ' Support Status')}
            onChange={handler}
          >
            <MenuItem value='Active'>Active</MenuItem>
            <MenuItem value='Expired'>Expired</MenuItem>
            <MenuItem value='None'>None</MenuItem>
          </Select>,
        ]}
      />
    </>
  );
};

export default SoftwareSoldFilterBar;
